'use strict';

var _RequestMethodTypeMap;
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ParameterDataTypeEnum = /*#__PURE__*/function (ParameterDataTypeEnum) {
  ParameterDataTypeEnum["Number"] = "number";
  ParameterDataTypeEnum["String"] = "string";
  ParameterDataTypeEnum["Integer"] = "integer";
  ParameterDataTypeEnum["Array"] = "array";
  ParameterDataTypeEnum["File"] = "file";
  // 仅1.4.14前版本可能会有text类型，新版本使用string代替text，旧版本text类型会客户端自动转换成string
  ParameterDataTypeEnum["Text"] = "text";
  ParameterDataTypeEnum["Boolean"] = "boolean";
  return ParameterDataTypeEnum;
}({});
var ApiStatusType = /*#__PURE__*/function (ApiStatusType) {
  ApiStatusType["designing"] = "designing";
  ApiStatusType["pending"] = "pending";
  ApiStatusType["developing"] = "developing";
  ApiStatusType["integrating"] = "integrating";
  ApiStatusType["testing"] = "testing";
  ApiStatusType["tested"] = "tested";
  ApiStatusType["released"] = "released";
  ApiStatusType["deprecated"] = "deprecated";
  ApiStatusType["exception"] = "exception";
  ApiStatusType["obsolete"] = "obsolete";
  return ApiStatusType;
}({});
var ApiStatusTypeMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ApiStatusType.designing, {
  labelLocale: 'api.status.designing',
  value: ApiStatusType.designing,
  color: 'lime'
}), ApiStatusType.integrating, {
  labelLocale: 'api.status.integrating',
  value: ApiStatusType.integrating,
  color: 'pink'
}), ApiStatusType.released, {
  labelLocale: 'api.status.released',
  value: ApiStatusType.released,
  color: 'green'
}), ApiStatusType.pending, {
  labelLocale: 'api.status.pending',
  value: ApiStatusType.pending,
  color: 'yellow'
}), ApiStatusType.testing, {
  labelLocale: 'api.status.testing',
  value: ApiStatusType.testing,
  color: 'orange'
}), ApiStatusType.deprecated, {
  labelLocale: 'api.status.deprecated',
  value: ApiStatusType.deprecated,
  color: '#aaa'
}), ApiStatusType.developing, {
  labelLocale: 'api.status.developing',
  value: ApiStatusType.developing,
  color: 'blue'
}), ApiStatusType.tested, {
  labelLocale: 'api.status.tested',
  value: ApiStatusType.tested,
  color: 'purple'
}), ApiStatusType.exception, {
  labelLocale: 'api.status.exception',
  value: ApiStatusType.exception,
  color: 'red'
}), ApiStatusType.obsolete, {
  labelLocale: 'api.status.obsolete',
  value: ApiStatusType.obsolete,
  color: '#aaa'
});
var ApiStatusTypeList = Object.values(ApiStatusTypeMap);
var SPAN = 3;
var ParametersLocationType = /*#__PURE__*/function (ParametersLocationType) {
  ParametersLocationType["Query"] = "query";
  ParametersLocationType["Path"] = "path";
  ParametersLocationType["Header"] = "header";
  ParametersLocationType["Cookie"] = "cookie";
  ParametersLocationType["Body"] = "body";
  ParametersLocationType["Auth"] = "auth";
  ParametersLocationType["AdvancedSettings"] = "advancedSettings";
  ParametersLocationType["PreProcessors"] = "preProcessors";
  ParametersLocationType["PostProcessors"] = "postProcessors";
  return ParametersLocationType;
}({});
var ParametersLocationTypeMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ParametersLocationType.Query, {
  label: 'query',
  value: ParametersLocationType.Query.valueOf()
}), ParametersLocationType.Path, {
  label: 'path',
  value: ParametersLocationType.Path.valueOf()
}), ParametersLocationType.Header, {
  label: 'header',
  value: ParametersLocationType.Header.valueOf()
}), ParametersLocationType.Cookie, {
  label: 'cookie',
  value: ParametersLocationType.Cookie.valueOf()
}), ParametersLocationType.Body, {
  label: 'body',
  value: ParametersLocationType.Body.valueOf()
}), ParametersLocationType.Auth, {
  label: 'auth',
  value: ParametersLocationType.Auth.valueOf()
});
var ParametersLocationTypeList = [ParametersLocationTypeMap[ParametersLocationType.Path], ParametersLocationTypeMap[ParametersLocationType.Query], ParametersLocationTypeMap[ParametersLocationType.Header], ParametersLocationTypeMap[ParametersLocationType.Cookie], ParametersLocationTypeMap[ParametersLocationType.Auth]];
var ParametersType = /*#__PURE__*/function (ParametersType) {
  ParametersType["Text"] = "text";
  ParametersType["File"] = "file";
  return ParametersType;
}({});
var ParametersTypeMap = _defineProperty(_defineProperty({}, ParametersType.Text, {
  label: ParametersType.Text.valueOf(),
  value: ParametersType.Text.valueOf()
}), ParametersType.File, {
  label: ParametersType.File.valueOf(),
  value: ParametersType.File.valueOf()
});
var ParametersTypeList = [ParametersTypeMap[ParametersType.Text], ParametersTypeMap[ParametersType.File]];
var RequestMethodType = /*#__PURE__*/function (RequestMethodType) {
  RequestMethodType["GET"] = "get";
  RequestMethodType["POST"] = "post";
  RequestMethodType["PUT"] = "put";
  RequestMethodType["DELETE"] = "delete";
  RequestMethodType["OPTIONS"] = "options";
  RequestMethodType["HEAD"] = "head";
  RequestMethodType["PATCH"] = "patch";
  RequestMethodType["TRACE"] = "trace";
  RequestMethodType["CONNECT"] = "connect";
  RequestMethodType["SOCKET"] = "socket";
  RequestMethodType["DUBBO"] = "dubbo";
  RequestMethodType["DOC"] = "doc";
  // WebDAV 方法且 当前 node 12 http 支持的 start
  RequestMethodType["COPY"] = "copy";
  RequestMethodType["LINK"] = "link";
  RequestMethodType["UNLINK"] = "unlink";
  RequestMethodType["PURGE"] = "purge";
  RequestMethodType["LOCK"] = "lock";
  RequestMethodType["UNLOCK"] = "unlock";
  RequestMethodType["MKCOL"] = "mkcol";
  RequestMethodType["MOVE"] = "move";
  RequestMethodType["PROPFIND"] = "propfind";
  RequestMethodType["REPORT"] = "report";
  RequestMethodType["VIEW"] = "view";
  // WebDAV 方法且 当前 node 12 http 支持的 end
  RequestMethodType["WS"] = "ws";
  return RequestMethodType;
}({});
var RequestMethodTypeMap = (_RequestMethodTypeMap = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_RequestMethodTypeMap, RequestMethodType.GET, {
  label: 'GET',
  labelAbbr: 'GET',
  value: RequestMethodType.GET.valueOf()
}), RequestMethodType.POST, {
  label: 'POST',
  labelAbbr: 'POST',
  value: RequestMethodType.POST.valueOf()
}), RequestMethodType.PUT, {
  label: 'PUT',
  labelAbbr: 'PUT',
  value: RequestMethodType.PUT.valueOf()
}), RequestMethodType.DELETE, {
  label: 'DELETE',
  labelAbbr: 'DEL',
  value: RequestMethodType.DELETE.valueOf()
}), RequestMethodType.OPTIONS, {
  label: 'OPTIONS',
  labelAbbr: 'OPT',
  value: RequestMethodType.OPTIONS.valueOf()
}), RequestMethodType.HEAD, {
  label: 'HEAD',
  labelAbbr: 'HEAD',
  value: RequestMethodType.HEAD.valueOf()
}), RequestMethodType.PATCH, {
  label: 'PATCH',
  labelAbbr: 'PAT',
  value: RequestMethodType.PATCH.valueOf()
}), RequestMethodType.TRACE, {
  label: 'TRACE',
  labelAbbr: 'TRA',
  value: RequestMethodType.TRACE.valueOf()
}), RequestMethodType.CONNECT, {
  label: 'CONNECT',
  labelAbbr: 'CON',
  value: RequestMethodType.CONNECT.valueOf()
}), RequestMethodType.SOCKET, {
  label: 'SOCKET',
  labelAbbr: 'SOCK',
  value: RequestMethodType.SOCKET.valueOf()
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_RequestMethodTypeMap, RequestMethodType.DUBBO, {
  label: 'DUBBO',
  labelAbbr: 'DUBB',
  value: RequestMethodType.DUBBO.valueOf()
}), RequestMethodType.DOC, {
  label: 'DOC',
  labelAbbr: 'DOC',
  value: RequestMethodType.DOC.valueOf()
}), RequestMethodType.COPY, {
  label: 'COPY',
  labelAbbr: 'COPY',
  value: RequestMethodType.COPY.valueOf()
}), RequestMethodType.LINK, {
  label: 'LINK',
  labelAbbr: 'LINK',
  value: RequestMethodType.LINK.valueOf()
}), RequestMethodType.UNLINK, {
  label: 'UNLINK',
  labelAbbr: 'ULIK',
  value: RequestMethodType.UNLINK.valueOf()
}), RequestMethodType.PURGE, {
  label: 'PURGE',
  labelAbbr: 'PURG',
  value: RequestMethodType.PURGE.valueOf()
}), RequestMethodType.LOCK, {
  label: 'LOCK',
  labelAbbr: 'LOCK',
  value: RequestMethodType.LOCK.valueOf()
}), RequestMethodType.UNLOCK, {
  label: 'UNLOCK',
  labelAbbr: 'ULOK',
  value: RequestMethodType.UNLOCK.valueOf()
}), RequestMethodType.MKCOL, {
  label: 'MKCOL',
  labelAbbr: 'MKCL',
  value: RequestMethodType.MKCOL.valueOf()
}), RequestMethodType.MOVE, {
  label: 'MOVE',
  labelAbbr: 'MOVE',
  value: RequestMethodType.MOVE.valueOf()
}), _defineProperty(_defineProperty(_defineProperty(_RequestMethodTypeMap, RequestMethodType.PROPFIND, {
  label: 'PROPFIND',
  labelAbbr: 'PFIN',
  value: RequestMethodType.PROPFIND.valueOf()
}), RequestMethodType.REPORT, {
  label: 'REPORT',
  labelAbbr: 'REP',
  value: RequestMethodType.REPORT.valueOf()
}), RequestMethodType.VIEW, {
  label: 'VIEW',
  labelAbbr: 'VIEW',
  value: RequestMethodType.VIEW.valueOf()
}));
var RequestMethodTypeList = [RequestMethodTypeMap[RequestMethodType.GET], RequestMethodTypeMap[RequestMethodType.POST], RequestMethodTypeMap[RequestMethodType.PUT], RequestMethodTypeMap[RequestMethodType.DELETE], RequestMethodTypeMap[RequestMethodType.OPTIONS], RequestMethodTypeMap[RequestMethodType.HEAD], RequestMethodTypeMap[RequestMethodType.PATCH], RequestMethodTypeMap[RequestMethodType.TRACE], RequestMethodTypeMap[RequestMethodType.CONNECT], RequestMethodTypeMap[RequestMethodType.COPY], RequestMethodTypeMap[RequestMethodType.LINK], RequestMethodTypeMap[RequestMethodType.UNLINK], RequestMethodTypeMap[RequestMethodType.PURGE], RequestMethodTypeMap[RequestMethodType.LOCK], RequestMethodTypeMap[RequestMethodType.UNLOCK], RequestMethodTypeMap[RequestMethodType.MKCOL], RequestMethodTypeMap[RequestMethodType.MOVE], RequestMethodTypeMap[RequestMethodType.PROPFIND], RequestMethodTypeMap[RequestMethodType.REPORT], RequestMethodTypeMap[RequestMethodType.VIEW]

// 不可选
// RequestMethodTypeMap[RequestMethodType.SOCKET],
// RequestMethodTypeMap[RequestMethodType.DOC],
// RequestMethodTypeMap[RequestMethodType.DUBBO],
];
var RequestBodyTypes = ['none', 'application/x-www-form-urlencoded', 'multipart/form-data', 'application/json', 'application/x-msgpack', 'application/xml', 'text/plain', 'application/octet-stream'];
var HttpApiRequestBodyType = /*#__PURE__*/function (HttpApiRequestBodyType) {
  HttpApiRequestBodyType["None"] = "none";
  HttpApiRequestBodyType["XWwwFormUrlencoded"] = "application/x-www-form-urlencoded";
  HttpApiRequestBodyType["FormData"] = "multipart/form-data";
  HttpApiRequestBodyType["Json"] = "application/json";
  HttpApiRequestBodyType["Xml"] = "application/xml";
  HttpApiRequestBodyType["Raw"] = "text/plain";
  HttpApiRequestBodyType["Binary"] = "application/octet-stream";
  HttpApiRequestBodyType["GraphQL"] = "graphql";
  HttpApiRequestBodyType["MsgPack"] = "application/x-msgpack";
  return HttpApiRequestBodyType;
}({});
var HttpApiRequestBodyTypeMap = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, HttpApiRequestBodyType.None, {
  label: 'none',
  value: HttpApiRequestBodyType.None.valueOf()
}), HttpApiRequestBodyType.FormData, {
  label: 'form-data',
  value: HttpApiRequestBodyType.FormData.valueOf()
}), HttpApiRequestBodyType.XWwwFormUrlencoded, {
  label: 'x-www-form-urlencoded',
  value: HttpApiRequestBodyType.XWwwFormUrlencoded.valueOf()
}), HttpApiRequestBodyType.MsgPack, {
  label: 'msgpack',
  value: HttpApiRequestBodyType.MsgPack.valueOf()
}), HttpApiRequestBodyType.Json, {
  label: 'json',
  value: HttpApiRequestBodyType.Json.valueOf()
}), HttpApiRequestBodyType.Xml, {
  label: 'xml',
  value: HttpApiRequestBodyType.Xml.valueOf()
}), HttpApiRequestBodyType.Raw, {
  label: 'raw',
  value: HttpApiRequestBodyType.Raw.valueOf()
}), HttpApiRequestBodyType.Binary, {
  label: 'binary',
  value: HttpApiRequestBodyType.Binary.valueOf()
}), HttpApiRequestBodyType.GraphQL, {
  label: 'GraphQL',
  value: HttpApiRequestBodyType.GraphQL.valueOf()
});
var HttpApiRequestBodyTypeList = [HttpApiRequestBodyTypeMap[HttpApiRequestBodyType.None], HttpApiRequestBodyTypeMap[HttpApiRequestBodyType.FormData], HttpApiRequestBodyTypeMap[HttpApiRequestBodyType.XWwwFormUrlencoded], HttpApiRequestBodyTypeMap[HttpApiRequestBodyType.Json], HttpApiRequestBodyTypeMap[HttpApiRequestBodyType.Xml], HttpApiRequestBodyTypeMap[HttpApiRequestBodyType.Raw], HttpApiRequestBodyTypeMap[HttpApiRequestBodyType.Binary], HttpApiRequestBodyTypeMap[HttpApiRequestBodyType.GraphQL], HttpApiRequestBodyTypeMap[HttpApiRequestBodyType.MsgPack]];
var HttpApiRequestBodyParameterType = /*#__PURE__*/function (HttpApiRequestBodyParameterType) {
  HttpApiRequestBodyParameterType[HttpApiRequestBodyParameterType["Text"] = 0] = "Text";
  HttpApiRequestBodyParameterType[HttpApiRequestBodyParameterType["File"] = 1] = "File";
  return HttpApiRequestBodyParameterType;
}({});
var ApiCaseSuggestNameSuffixList = ['success', 'failure', 'notFound', 'empty', 'missingParameter', 'parameterInvalid', 'authed', 'unAuthed', 'permissionDenied', 'normal'];
/**
 * @description 由于 httpApiCase 数据合并逻辑实现没有向后兼容，非原始值(primitive value)的属性都需要赋值一个默认的值
 */

var HttpApiBatchAction = /*#__PURE__*/function (HttpApiBatchAction) {
  HttpApiBatchAction["DELETE"] = "DELETE";
  HttpApiBatchAction["ADD_TAGS"] = "ADD_TAGS";
  HttpApiBatchAction["DELETE_TAGS"] = "DELETE_TAGS";
  HttpApiBatchAction["UPDATE_STATUS"] = "UPDATE_STATUS";
  HttpApiBatchAction["CHANGE_MAINTAINER"] = "CHANGE_MAINTAINER";
  HttpApiBatchAction["CHANGE_FOLDER"] = "CHANGE_FOLDER";
  HttpApiBatchAction["CREATE_BRANCH_COPY"] = "CREATE_BRANCH_COPY";
  return HttpApiBatchAction;
}({});
var HttpApiContentTypeDefaultValue = {
  json: 'application/json',
  binary: 'application/octet-stream',
  html: 'text/html',
  eventStream: 'text/event-stream',
  msgpack: 'application/x-msgpack',
  raw: 'text/plain',
  xml: 'application/xml'
};
var HTTPApiCopyType = /*#__PURE__*/function (HTTPApiCopyType) {
  HTTPApiCopyType["CONTENT"] = "content";
  HTTPApiCopyType["URL"] = "url";
  return HTTPApiCopyType;
}({});
var UserOS = /*#__PURE__*/function (UserOS) {
  UserOS["MACOS_OR_LINUX"] = "macos_or_linux";
  UserOS["WINDOWS"] = "windows";
  return UserOS;
}({});
var AICodeEditorKeys = /*#__PURE__*/function (AICodeEditorKeys) {
  AICodeEditorKeys["CURSOR"] = "cursor";
  AICodeEditorKeys["VSCODE"] = "vscode";
  AICodeEditorKeys["CLINE"] = "cline";
  AICodeEditorKeys["WINDSTORM"] = "windstorm";
  AICodeEditorKeys["TRAE"] = "trae";
  AICodeEditorKeys["OTHER"] = "other";
  return AICodeEditorKeys;
}({});
var AICodeEditorSize = /*#__PURE__*/function (AICodeEditorSize) {
  AICodeEditorSize[AICodeEditorSize["SIZE_16"] = 16] = "SIZE_16";
  AICodeEditorSize[AICodeEditorSize["SIZE_12"] = 12] = "SIZE_12";
  return AICodeEditorSize;
}({});
exports.AICodeEditorKeys = AICodeEditorKeys;
exports.AICodeEditorSize = AICodeEditorSize;
exports.ApiCaseSuggestNameSuffixList = ApiCaseSuggestNameSuffixList;
exports.ApiStatusType = ApiStatusType;
exports.ApiStatusTypeList = ApiStatusTypeList;
exports.ApiStatusTypeMap = ApiStatusTypeMap;
exports.HTTPApiCopyType = HTTPApiCopyType;
exports.HttpApiBatchAction = HttpApiBatchAction;
exports.HttpApiContentTypeDefaultValue = HttpApiContentTypeDefaultValue;
exports.HttpApiRequestBodyParameterType = HttpApiRequestBodyParameterType;
exports.HttpApiRequestBodyType = HttpApiRequestBodyType;
exports.HttpApiRequestBodyTypeList = HttpApiRequestBodyTypeList;
exports.HttpApiRequestBodyTypeMap = HttpApiRequestBodyTypeMap;
exports.ParameterDataTypeEnum = ParameterDataTypeEnum;
exports.ParametersLocationType = ParametersLocationType;
exports.ParametersLocationTypeList = ParametersLocationTypeList;
exports.ParametersLocationTypeMap = ParametersLocationTypeMap;
exports.ParametersType = ParametersType;
exports.ParametersTypeList = ParametersTypeList;
exports.ParametersTypeMap = ParametersTypeMap;
exports.RequestBodyTypes = RequestBodyTypes;
exports.RequestMethodType = RequestMethodType;
exports.RequestMethodTypeList = RequestMethodTypeList;
exports.RequestMethodTypeMap = RequestMethodTypeMap;
exports.SPAN = SPAN;
exports.UserOS = UserOS;
